namespace Matrix.Workflow {
    export class TaskStatusColumns {
        static columnsKey = 'Workflow.TaskStatus';
    }
}
